import React from 'react';
import { faqs } from '../mock';
import { Plus, Minus } from 'lucide-react';

export default function FAQ() {
  const [open, setOpen] = React.useState(0);
  return (
    <section id="faq" className="px-5 sm:px-8 mt-24">
      <div className="mx-auto max-w-[1000px]">
        <div className="pb-10 text-center">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
            <span className="tag-dot" /> Questions
          </div>
          <h2 className="font-grotesk mt-3 text-4xl sm:text-5xl tracking-[-0.02em] font-medium">Answered.</h2>
        </div>

        <div className="rounded-2xl border border-black/5 dark:border-white/5 overflow-hidden">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`border-t first:border-t-0 border-black/5 dark:border-white/5 ${isOpen ? 'bg-[color:var(--cv-teal-soft)]/40 dark:bg-white/[0.03]' : ''}`}>
                <button onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-center justify-between text-left px-6 py-5 gap-4">
                  <span className="font-grotesk font-medium text-[17px]">{f.q}</span>
                  <span className="shrink-0 h-8 w-8 rounded-full border border-black/10 dark:border-white/10 inline-flex items-center justify-center">
                    {isOpen ? <Minus size={14} /> : <Plus size={14} />}
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-[15px] text-neutral-600 dark:text-neutral-300 leading-relaxed max-w-3xl">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
